import {Checkout} from "../Checkout/Checkout";
import { useLocation, useSearchParams } from "react-router-dom";
export const VerifyWithCrdx = () => {
    const location = useLocation();
    const mitigationAction = location.pathname.split('/'); 
    const [searchParams] = useSearchParams();
    const token = searchParams.get('id');
    const pspId = searchParams.get('pspId');
    const offerName = searchParams.get('name');
    const productId = searchParams.get('pId');
    const setupPeriod = searchParams.get('sp');
    const src = searchParams.get('src');
    const curr = searchParams.get('curr');
    const businessTermsBeforeParsing = searchParams.get('bt').replace(/\\/g, '');;
    const businessTerms = JSON.parse(businessTermsBeforeParsing)
    
    return (
        <div>
            <Checkout mitigationAction={mitigationAction[1]} token={token} src={src} curr={curr} pspId={pspId} offerName={offerName} productId={productId} setupPeriod={setupPeriod} businessTermsProp={businessTerms}/>
        </div>
    )
}